import React, { FunctionComponent, useEffect, useState, useRef, useCallback } from "react";
import { Row, Col, Dropdown } from "react-bootstrap";
import axios from "axios";

import {
  BaseSelect,
  BaseDropdown,
  BaseForm,
  CurrencyInput,
  BaseFieldSet,
  EmailInput,
  BaseInput,
  FilterOperator,
  StateInput,
  DateInput,
} from "react-epharma-components";
import { First } from "react-bootstrap/PageItem";

const CrudForm: FunctionComponent = (props) => {
  const id = React.createRef<any>();
  const chain = React.createRef<any>();
  const client = React.createRef<any>();
  const benefit = React.createRef<any>();
  const product = React.createRef<any>();
  const presentation = React.createRef<any>();
  const startDate = React.createRef<any>();
  const endDate = React.createRef<any>();
  const corporateName = React.createRef<any>();
  const tradeName = React.createRef<any>();
  const nameBenefit = React.createRef<any>();
  const commisionValue = React.createRef<any>();
  const inclusionDate = React.createRef<any>();
  const creationUsername = React.createRef<any>();

  const _this = React.createRef<BaseForm>();

  const hasConflictRef = useRef(false);
  const isCheckingRef = useRef(false);
  const [conflictMessage, setConflictMessage] = useState('');

  const inputRefs = [
    id,
    product,
    presentation,
    startDate,
    endDate,
    corporateName,
    tradeName,
    nameBenefit,
    commisionValue,
    inclusionDate,
    creationUsername,
  ];

  const basechainEndpoint = window.chainService.base; //Rede
  const baseclientEndpoint = window.clientService.base; //Cliente
  const baseproductEndpoint = window.productService.base; //Produto

  const chainEndpoint = basechainEndpoint + window.chainService.chain; //Rede
  const clientEndpoint = baseclientEndpoint + window.clientService.client; //Cliente
  const benefitEndpoint = baseclientEndpoint + window.clientService.benefit; //Plano (Benefício)
  const productEndpoint = baseproductEndpoint + window.productService.product; //Produto
  const presentationEndpoint = baseproductEndpoint + window.productService.presentation; //Apresentação
  const commisionEndpoint = basechainEndpoint + window.chainService.comissionChain; //Comissão

  const checkForOverlap = useCallback(async () => {
    const chainIdVal = corporateName.current?.getValue();
    const clientIdVal = tradeName.current?.getValue();
    const startDateVal = startDate.current?.getValue();
    const idVal = id.current?.getValue();

    if (!chainIdVal || !startDateVal) {
      hasConflictRef.current = false;
      setConflictMessage('');
      return;
    }

    isCheckingRef.current = true;
    try {
      const params = new URLSearchParams({
        chainId: chainIdVal,
        startDate: startDateVal,
      });
      if (clientIdVal) params.append('clientId', clientIdVal);
      if (endDate.current?.getValue()) params.append('endDate', endDate.current.getValue());
      if (idVal) params.append('excludeId', idVal);

      const endpoint = window.chainService.base + window.chainService.validateOverlap;
      const response = await axios.get(`${endpoint}?${params}`);
      const result = response.data;

      hasConflictRef.current = result.data?.hasConflict ?? false;
      setConflictMessage(result.data?.message ?? '');
    } catch {
      hasConflictRef.current = false;
      setConflictMessage('');
    } finally {
      isCheckingRef.current = false;
    }
  }, []);

  useEffect(() => {
    console.log(_this.current?.baseForm);
  }, [_this.current]);

  return (
    <BaseForm refs={inputRefs} {...props} ref={_this}>
      <BaseFieldSet legend="" collapsible={false}>
        <Row>
          <BaseInput name="id" ref={id} identifier hidden />
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <BaseDropdown
              name="chainId"
              label="Rede"
              type="string"
              labelProperty="corporateName"
              valueProperty="id"
              ref={corporateName}
              endpoint={chainEndpoint}
              required
              identifier
              onSelect={() => checkForOverlap()}
            />
          </Col>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <BaseDropdown
              name="clientId"
              label="Cliente"
              type="string"
              labelProperty="tradeName"
              valueProperty="id"
              ref={tradeName}
              childField={nameBenefit}
              childFieldProperty="clientId"
              endpoint={clientEndpoint}
              identifier
              onSelect={() => checkForOverlap()}
            />
          </Col>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <BaseDropdown
              name="benefitId"
              label="Plano (Benefício)"
              type="string"
              labelProperty="name"
              ref={nameBenefit}
              endpoint={benefitEndpoint}
              identifier
            />
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <BaseDropdown
              name="productId"
              label="Produto"
              type="string"
              labelProperty="name"
              valueProperty="id"
              ref={product}
              childField={presentation}
              childFieldProperty="productId"
              endpoint={productEndpoint}
              identifier
            />
          </Col>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <BaseDropdown
              name="presentationId"
              label="Apresentação"
              type="string"
              labelProperty="name"
              ref={presentation}
              endpoint={presentationEndpoint}
              identifier
            />
          </Col>
          <Col xs="8" sm="8" md="4" lg="4" xl="4">
            <CurrencyInput
              name="commisionValue"
              label="% de Comissão"
              maskOptions={{
                prefix: "",
                suffix: "%",
                allowNegative: false,
                integerLimit: 3,
                allowDecimal: true,
              }}
              max={100}
              min={0}
              ref={commisionValue}
            />
          </Col>
        </Row>
        <Row>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <DateInput
              name="startDate"
              label="Início"
              ref={startDate}
              isDate
              required
              callbackChange={() => checkForOverlap()}
              onCustomValidationIsInvalid={() => hasConflictRef.current || isCheckingRef.current}
              onDefineMsgInvalidOverride={() =>
                isCheckingRef.current ? 'Verificando taxas vigentes...' : conflictMessage
              }
            />
          </Col>
          <Col xs="12" sm="12" md="6" lg="6" xl="4">
            <DateInput
              name="endDate"
              label="Fim"
              ref={endDate}
              isDate
              callbackChange={() => checkForOverlap()}
            />
          </Col>
        </Row>
      </BaseFieldSet>
    </BaseForm>
  );
};

export default CrudForm;
